<app-navbar-style-three></app-navbar-style-three>

<section class="administration-section">
  <div class="container">
    <!-- Header -->
    <div class="section-header">
      <div class="section-header__icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path d="M12 14L21 9L12 4L3 9L12 14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M12 14L21 9V16C21 16.5304 20.7893 17.0391 20.4142 17.4142C20.0391 17.7893 19.5304 18 19 18H5C4.46957 18 3.96086 17.7893 3.58579 17.4142C3.21071 17.0391 3 16.5304 3 16V9L12 14Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <h1 class="section-header__title">Administration</h1>
    </div>

    <!-- Main Content -->
    <div class="administration-content" *ngIf="!fetchinData">
      <div class="administration-grid">
        <!-- Sidebar Navigation -->
        <aside class="admin-sidebar">
          <nav class="admin-nav">
            <button *ngFor="let item of items; let i = index"
              [class.admin-nav__item--active]="selectedItem === item.Url" (click)="selectItem(item.Url)"
              class="admin-nav__item" [attr.data-index]="i">
              <span class="admin-nav__indicator"></span>
              <span class="admin-nav__text">{{ item.Name }}</span>
              <svg class="admin-nav__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </nav>
        </aside>

        <!-- Content Area -->
        <main class="admin-main">
          <!-- Header (for Governing Body, Teachers, Staff) -->
          <div class="admin-main__header" *ngIf="selectedItem === 'governing-body' || selectedItem === 'teacher-information' || selectedItem === 'staff-information'">
            <h2 class="admin-main__title">{{ selectedItemName }}</h2>
            <div class="admin-main__divider"></div>
          </div>

          <!-- Governing Body -->
          <div class="admin-content" *ngIf="selectedItem && selectedItem === 'governing-body'">
            <!-- Empty State -->
            <div class="empty-state" *ngIf="GBs == null">
              <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
                <path
                  d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                  d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p class="empty-state__text">No data found</p>
            </div>

            <!-- Team Grid -->
            <div class="team-section" *ngIf="GBs != null">
              <!-- Chairman/President -->
              <div class="team-grid team-grid--featured" *ngIf="GBs1 != null">
                <article class="team-card team-card--featured">
                  <div class="team-card__image-wrapper">
                    <img [src]="GBs1.ImagePath" [alt]="GBs1.Name" class="team-card__image" loading="lazy" />
                  </div>
                  <div class="team-card__content">
                    <h3 class="team-card__name">{{ GBs1.Name }}</h3>
                    <p class="team-card__position" *ngIf="GBs1.GBDesignation">{{ GBs1.GBDesignation }}</p>
                    <div class="team-card__badge-wrapper">
                      <span class="team-card__badge-pill">{{ GBs1.GBPosition || GBs1.GBDesignation || 'CHAIRMAN' }}</span>
                    </div>
                  </div>
                </article>
              </div>

              <!-- Other Members -->
              <div class="team-grid" *ngIf="GBs2 != null && GBs2.length > 0">
                <article class="team-card" *ngFor="let item of GBs2; let i = index" [attr.data-index]="i">
                  <div class="team-card__image-wrapper">
                    <img [src]="item.ImagePath" [alt]="item.Name" class="team-card__image" loading="lazy" />
                  </div>
                  <div class="team-card__content">
                    <h3 class="team-card__name">{{ item.Name }}</h3>
                    <p class="team-card__position" *ngIf="item.GBDesignation">{{ item.GBDesignation }}</p>
                    <div class="team-card__badge-wrapper">
                      <span class="team-card__badge-pill">{{ item.GBPosition || 'MEMBER' }}</span>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>

          <!-- Teacher Information -->
          <div class="admin-content" *ngIf="selectedItem && selectedItem === 'teacher-information'">
            <!-- Empty State -->
            <div class="empty-state" *ngIf="TeacherInfo == null || TeacherInfo.length === 0">
              <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
                <path
                  d="M22 10V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V10"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2 10H22" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M12 14V20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <p class="empty-state__text">No teacher information available</p>
            </div>

            <!-- Teachers Grid -->
            <div class="team-grid" *ngIf="TeacherInfo != null && TeacherInfo.length > 0">
              <article class="team-card" *ngFor="let item of TeacherInfo; let i = index" [attr.data-index]="i">
                <div class="team-card__image-wrapper">
                  <img [src]="item.ImageLink" [alt]="item.EmployeeName" class="team-card__image" loading="lazy" />
                </div>
                <div class="team-card__content">
                  <h3 class="team-card__name">{{ item.EmployeeName }}</h3>
                  <p class="team-card__position">{{ item.Designation }}</p>
                </div>
              </article>
            </div>
          </div>

          <!-- Staff Information -->
          <div class="admin-content" *ngIf="selectedItem && selectedItem === 'staff-information'">
            <!-- Empty State -->
            <div class="empty-state" *ngIf="StaffInfo == null || StaffInfo.length === 0">
              <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
                <path
                  d="M22 10V6C22 5.46957 21.7893 4.96086 21.4142 4.58579C21.0391 4.21071 20.5304 4 20 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V10"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M2 10H22" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M12 14V20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <p class="empty-state__text">No staff information available</p>
            </div>

            <!-- Staff Grid -->
            <div class="team-grid" *ngIf="StaffInfo != null && StaffInfo.length > 0">
              <article class="team-card" *ngFor="let item of StaffInfo; let i = index" [attr.data-index]="i">
                <div class="team-card__image-wrapper">
                  <img [src]="item.ImageLink" [alt]="item.EmployeeName" class="team-card__image" loading="lazy" />
                </div>
                <div class="team-card__content">
                  <h3 class="team-card__name">{{ item.EmployeeName }}</h3>
                  <p class="team-card__position">{{ item.Designation }}</p>
                </div>
              </article>
            </div>
          </div>

          <!-- Message/Other Content -->
          <div class="admin-content"
            *ngIf="selectedItem && selectedItem !== 'governing-body' && selectedItem !== 'teacher-information' && selectedItem !== 'staff-information'">
            <!-- Empty State -->
            <div class="empty-state" *ngIf="GBms == null || GBms1 == null">
              <svg class="empty-state__icon" width="80" height="80" viewBox="0 0 24 24" fill="none">
                <path
                  d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
              <p class="empty-state__text">No message found</p>
            </div>

            <!-- Message Card Matching Image 100% -->
            <article class="msg-card" *ngIf="GBms1">
              <!-- Left Profile Column -->
              <div class="msg-card__left">
                <!-- Background Vector Artwork Matching Screenshot 100% -->
                <div class="msg-card__bg-art">
                  <svg viewBox="0 0 320 600" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="mainWaveGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stop-color="#0ea5e9" />
                        <stop offset="50%" stop-color="#0284c7" />
                        <stop offset="100%" stop-color="#0066b3" />
                      </linearGradient>
                      <linearGradient id="lightWaveGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stop-color="#bae6fd" stop-opacity="0.6" />
                        <stop offset="100%" stop-color="#38bdf8" stop-opacity="0.3" />
                      </linearGradient>
                      <linearGradient id="midWaveGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stop-color="#7dd3fc" stop-opacity="0.5" />
                        <stop offset="100%" stop-color="#0284c7" stop-opacity="0.4" />
                      </linearGradient>
                    </defs>

                    <!-- Top-left to bottom flowing curved lines -->
                    <path d="M 0,20 C 60,80 30,160 50,260 C 70,360 130,440 260,600" fill="none" stroke="#7dd3fc" stroke-width="1.5" opacity="0.6" />
                    <path d="M 0,60 C 80,120 40,200 70,300 C 100,400 170,480 300,600" fill="none" stroke="#38bdf8" stroke-width="2" opacity="0.5" />
                    <path d="M 0,100 C 90,160 60,240 90,340 C 120,440 190,510 320,580" fill="none" stroke="#bae6fd" stroke-width="1.5" opacity="0.7" />
                    <path d="M 0,140 C 100,200 80,280 110,380 C 140,470 210,530 320,550" fill="none" stroke="#e0f2fe" stroke-width="2" opacity="0.8" />

                    <!-- Layer 1: Outermost soft light blue wave -->
                    <path d="M 0,260 C 40,300 80,360 130,420 C 180,480 240,540 320,600 L 0,600 Z" fill="url(#lightWaveGrad)" />

                    <!-- Layer 2: Mid blue curved wave -->
                    <path d="M 0,320 C 40,360 85,420 135,475 C 180,520 225,565 275,600 L 0,600 Z" fill="url(#midWaveGrad)" />

                    <!-- Layer 3: Solid bold gradient blue sail wave matching image -->
                    <path d="M 0,380 C 35,415 70,465 110,505 C 150,545 180,575 230,600 L 0,600 Z" fill="url(#mainWaveGrad)" />
                  </svg>
                </div>

                <!-- Circular Photo -->
                <div class="msg-card__photo-wrapper">
                  <img [src]="GBms1.GBImagePath" [alt]="GBms1.GBName || 'Photo'" class="msg-card__photo" loading="lazy" />
                </div>
                
                <!-- Name & Subtitle -->
                <div class="msg-card__profile-info">
                  <h4 class="msg-card__name">{{ GBms1.GBName || GBms1.Name }}</h4>
                  <p class="msg-card__desig" *ngIf="GBms1.GBDesignationName || GBms1.GBDesignation">
                    {{ GBms1.GBDesignationName || GBms1.GBDesignation }}
                  </p>
                </div>
              </div>

              <!-- Right Message Body Column -->
              <div class="msg-card__right">
                <!-- Top Header Bar -->
                <div class="msg-card__header-bar">
                  <h3>{{ (GBms1.TitleEn && GBms1.TitleEn.toLowerCase() !== 'test') ? GBms1.TitleEn.toUpperCase() : formatMessageTitle(selectedItemName) }}</h3>
                </div>

                <!-- Message Body Text -->
                <div class="msg-card__body" [innerHTML]="GBms1.DetailsEn"></div>
              </div>
            </article>
          </div>
        </main>
      </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="fetchinData">
      <div class="loading-grid">
        <div class="skeleton skeleton--sidebar">
          <div class="skeleton__line skeleton__line--nav" *ngFor="let i of [1,2,3,4,5]"></div>
        </div>
        <div class="skeleton skeleton--content">
          <div class="skeleton__header"></div>
          <div class="skeleton__line" *ngFor="let i of [1,2,3,4,5,6]"></div>
        </div>
      </div>
    </div>
  </div>
</section>